import { useState, useEffect } from "react";
import { Form, Row, Col, Input, Modal } from "antd";

import dayjs from 'dayjs';

import { NumericFormat, PatternFormat } from "react-number-format";


import type { IEfpc, IFundamentacaoLegal, IPessoaJuridica, ISelectList } from "../../../components/Interfaces";

import { carregaListaFundamentacaoLegal } from "../../PessoaJuridica/services";
import { maskNuMatricula } from "../../../utils/maskFunctions";

interface IProps {
  dadosEfpc: IEfpc | undefined;
  modalEfpcSucessoAberto: boolean;
  setModalEfpcSucessoAberto: React.Dispatch<React.SetStateAction<boolean>>;
}

const ModalEfpc = ({ dadosEfpc, modalEfpcSucessoAberto, setModalEfpcSucessoAberto }: IProps) => {

  const [form] = Form.useForm();

  const [pessoaJuridicaEfpc, setPessoaJuridicaEfpc] = useState<IPessoaJuridica>();

  const [listFundamentacaoLegal, setListFundamentacaoLegal] = useState<ISelectList[]>([]);
  const [fundamentacaoLegal, setFundamentacaoLegal] = useState(-1);
  const [numeroProcessoEfpcFormato, setNumeroProcessoEfpcFormato] = useState("#####.######/####-##")


  useEffect(() => {
    window.scrollTo(0, 0)
    //console.log(dadosEfpc);

    const carregaDadosIniciais = async () => {
      if (listFundamentacaoLegal.length === 0) carregaListaFundamentacaoLegalOpcoes();
      carregaDetalhesEfpc();
    }
    carregaDadosIniciais();

  }, [dadosEfpc]);

  useEffect(() => {
    if (listFundamentacaoLegal && listFundamentacaoLegal.length > 0 && fundamentacaoLegal >= 0) {
      form.setFieldsValue({
        nmFundamentacaoLegal: listFundamentacaoLegal.find(l => l.value === fundamentacaoLegal)?.label
      });

    }
  }, [fundamentacaoLegal, listFundamentacaoLegal]);


  const carregaDetalhesEfpc = () => {
    if (dadosEfpc) {
      setFundamentacaoLegal(dadosEfpc.fundamentacaoLegal);
      setPessoaJuridicaEfpc(dadosEfpc.pessoaJuridicaEfpc);
      if (dadosEfpc?.pessoaJuridicaEfpc?.numeroProcesso?.length !== 15)
        setNumeroProcessoEfpcFormato("####################");

      form.setFieldsValue({
        sigla: dadosEfpc.sigla,
        numero: maskNuMatricula(dadosEfpc.numero),
        tipo: dadosEfpc.tipo,
        nmFundamentacaoLegal: listFundamentacaoLegal.find(l => l.value === dadosEfpc.fundamentacaoLegal)?.label,
        quantidadeDiretores: dadosEfpc.quantidadeDiretores,
        nmEsi: dadosEfpc.nomeEnquadramento,
        quantidadeConselheiroFiscal: dadosEfpc.quantidadeConselheiroFiscal,
        quantidadeConselhoDeliberativo: dadosEfpc.quantidadeConselhoDeliberativo,
        nmSituacao: dadosEfpc.situacaoAtualEfpc + (dadosEfpc.situacaoAtualSecundariaEfpc ? " - " + dadosEfpc.situacaoAtualSecundariaEfpc : ""),
        dataSituacao: dadosEfpc.dataVigencia ? dayjs(dadosEfpc.dataVigencia).format('DD/MM/YYYY') : undefined,
        dataAprovacaoAutorizacao: dadosEfpc.dataAutorizacao ? dayjs(dadosEfpc.dataAutorizacao).format('DD/MM/YYYY') : undefined,
        dataInicioFuncionamento: dadosEfpc.dataInicioFuncionamento ? dayjs(dadosEfpc.dataInicioFuncionamento).format('DD/MM/YYYY') : undefined,
      });

      if (dadosEfpc.pessoaJuridicaEfpc) {
        form.setFieldsValue({
          efpcNumeroEfpcCnpj: dadosEfpc.pessoaJuridicaEfpc.tipoIdentificador === 1 ? dadosEfpc.pessoaJuridicaEfpc.numero : undefined,
          efpcNumeroEfpcProcesso: dadosEfpc.pessoaJuridicaEfpc.tipoIdentificador === 3 ? dadosEfpc.pessoaJuridicaEfpc.numero : undefined,
          efpcNumeroProcesso: dadosEfpc.pessoaJuridicaEfpc.numeroProcesso,
          efpcRazaoSocial: dadosEfpc.pessoaJuridicaEfpc.razaoSocial
        });

      };
    };
  };

  const carregaListaFundamentacaoLegalOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaFundamentacaoLegal().then((response) => {
      response.data.forEach((p: IFundamentacaoLegal) => {
        listaLocal.push({ value: p.codigo, label: p.descricao });
      });
    });
    setListFundamentacaoLegal(listaLocal);
  }

  const handleModalOk = () => {
    setModalEfpcSucessoAberto(false);
  };

  return (
    <Modal title="Entidade"
      width={"80%"}
      closable={false}
      open={modalEfpcSucessoAberto} onOk={handleModalOk}
      cancelButtonProps={{ disabled: true }}>
      <Form layout='vertical' style={{ padding: 24 }} form={form} >
        <div className="main-content pl-sm-3 mt-4">
          <h1>Detalhar Entidade</h1>
        </div>

        <div className="main-content pl-sm-3 mt-4">
          <h2>Informações Básicas da Entidade</h2>
        </div>

        <Row>
          <Col xs={24} xl={5} hidden={pessoaJuridicaEfpc?.tipoIdentificador === 3}>
            <Form.Item
              label="CNPJ da Entidade"
              name="efpcNumeroEfpcCnpj">
              <PatternFormat
                disabled
                customInput={Input}
                format="##.###.###/####-##"
              />
            </Form.Item>
          </Col>

          <Col xs={24} xl={7} hidden={pessoaJuridicaEfpc?.tipoIdentificador !== 3}>
            <Form.Item
              label="Identificador Provisório (Processo)"
              name="efpcNumeroEfpcProcesso">
              <PatternFormat
                disabled
                customInput={Input}
                format="#####.######/####-##"
              />
            </Form.Item>
          </Col>

          <Col xs={24} xl={7} hidden={pessoaJuridicaEfpc?.tipoIdentificador !== 3}>
            <Form.Item
              label='CNPJ'
              name='cnpjNumero'>
              <Input maxLength={18}
                disabled
              />
            </Form.Item>
          </Col>


          <Col xs={24} xl={5} hidden={pessoaJuridicaEfpc?.tipoIdentificador === 3}>
            <Form.Item
              label="Número do processo"
              name="efpcNumeroProcesso">
              <PatternFormat
                customInput={Input}
                format={numeroProcessoEfpcFormato}
                disabled
              />
            </Form.Item>
          </Col>

          <Col xs={24} xl={10}>
            <Form.Item label="Razão Social"
              name="efpcRazaoSocial">
              <Input disabled={true} />
            </Form.Item>
          </Col>
        </Row>

        <div className="main-content pl-sm-3 mt-4">
          <h2>Perfil da Entidade</h2>
        </div>

        <Row>
          <Col xs={24} md={12} xl={4}>
            <Form.Item
              label="Código"
              name="numero"
            >
              <Input disabled />
            </Form.Item>
          </Col>

          <Col xs={24} md={12} xl={4}>
            <Form.Item
              label="Sigla"
              name="sigla"
            >
              <Input disabled />
            </Form.Item>
          </Col>

          <Col xs={24} md={12} xl={4}>
            <Form.Item
              label="Tipo"
              name="tipo"
            >
              <Input disabled />
            </Form.Item>
          </Col>

          <Col xs={24} md={12} xl={5}>
            <Form.Item
              label="Fundamentação Legal"
              name="nmFundamentacaoLegal"
            >
              <Input disabled />
            </Form.Item>
          </Col>

          <Col xs={24} md={12} xl={7}>
            <Form.Item
              label="Tipo de Convenente Predominante"
              name="tipoConvenente"
            >
              <Input placeholder="CAMPO CALCULADO" disabled />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          {/* <Col xs={24} md={12} xl={8}>
            <Form.Item
              label="ESI"
              name="nmEsi"
            >
              <Input placeholder="SEM INFORMAÇÃO" disabled />
            </Form.Item>
          </Col> */}

          <Col xs={24} xl={5}>
            <Form.Item
              label="Qtd. Máx Diretores Executivos"
              name="quantidadeDiretores"
            >
              <NumericFormat
                disabled
                customInput={Input}
                placeholder="Digitar Qtd. Máx de diretores Executivos"
                allowNegative={false}
              />
            </Form.Item>
          </Col>

          <Col xs={24} md={12} xl={5}>
            <Form.Item
              label="Qtd. Máx Conselheiros Fiscais"
              name="quantidadeConselheiroFiscal"
            >
              <NumericFormat
                disabled
                customInput={Input}
                placeholder="Digitar Qtd. Máx de Conselheiros Fiscais"
                allowNegative={false}
              />
            </Form.Item>
          </Col>

          <Col xs={24} md={12} xl={6}>
            <Form.Item
              label="Qtd. Máx Conselheiros Deliberativos"
              name="quantidadeConselhoDeliberativo"
            >
              <NumericFormat
                disabled
                customInput={Input}
                placeholder="Digitar Qtd. Máx de Conselheiros Deliberativos"
                allowNegative={false}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col xs={24} md={10} xl={10}>
            <Form.Item
              label="Situação"
              name="nmSituacao">
              <Input disabled />
            </Form.Item>
          </Col>

          <Col xs={24} md={12} xl={6}>
            <Form.Item
              label="Data da Situação"
              name="dataSituacao">
              <Input disabled />
            </Form.Item>
          </Col>

          <Col xs={24} md={12} xl={8}>
            <Form.Item
              label="Qualificação Quanto ao Número de Planos"
              name="qnp"
            >
              <Input placeholder="CAMPO CALCULADO" disabled />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col xs={24} md={12} xl={6}>
            <Form.Item
              label="Data da Autorização"
              name="dataAprovacaoAutorizacao"
            >
              <Input disabled />
            </Form.Item>
          </Col>

          <Col xs={24} md={12} xl={6}>
            <Form.Item
              label="Data de início de Funcionamento"
              name="dataInicioFuncionamento"
            >
              <Input disabled />
            </Form.Item>
          </Col>

          <Col xs={24} md={12} xl={6}>
            <Form.Item
              label="Data de Encerramento"
              name="dataEncerramento"
            >
              <Input disabled />
            </Form.Item>
          </Col>

        </Row>
      </Form>
    </Modal>


  );
};

export default ModalEfpc;